import { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ScannerForm from "components/scanner/ScannerForm";
import { getScannerById, updateScanner } from "api/scanner.api";
import Alert from "components/common/Alert";
// import SuccessModal from "components/SuccessModal";
import Toast from "components/Toast";

export default function EditScanner() {
  const { id } = useParams();
  const navigate = useNavigate();
  // const [showSuccess, setShowSuccess] = useState(false);

  const [initialData, setInitialData] = useState(null);
  const [alert, setAlert] = useState(null);
  const alertRef = useRef(null);
  const [userId, setUserId] = useState(null);
  const [toast, setToast] = useState({
    open: false,
    title: "",
    message: "",
    type: "success",
  });

  const companyId = localStorage.getItem("company_id");

  useEffect(() => {
    if (alert && alertRef.current) {
      alertRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [alert]);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    if (userData) {
      setUserId(userData.userId);
    }
    const fetchScanner = async () => {
      try {
        const res = await getScannerById(id);
        // Handle response payload whether nested in .data or direct
        setInitialData(res.data.data.scanner || {});
      } catch (err) {
        setAlert({
          type: "error",
          message:
            err.response?.data?.message || "Failed to load scanner details",
        });
      }
    };

    if (id) fetchScanner();
  }, [id]);

  if (!initialData) return <p className="p-6">Loading...</p>;

  return (
    <>
      {alert && (
        <div ref={alertRef}>
          <Alert
            type={alert.type}
            message={alert.message}
            onClose={() => setAlert(null)}
          />
        </div>
      )}

      <ScannerForm
        initialData={initialData}
        isEdit
        submitLabel="Update Scanner"
        onSubmit={async (formData) => {
          try {
            const payload = {
              ...formData,
              company_id: companyId,
              userId: userId,
            };

            const res = await updateScanner(id, payload);
            if (res.data.success) {
              setToast({
                open: true,
                title: "Updated Successfully!",
                message: "Scanner has been updated successfully.",
                type: "success",
              });
            }

            // navigate("/admin/scanners");
          } catch (error) {
            setAlert({
              type: "error",
              message:
                error.response?.data?.message || "Failed to update scanner",
            });
          }
        }}
        onBack={() => navigate("/admin/scanners")}
      />
      <Toast
        open={toast.open}
        title={toast.title}
        message={toast.message}
        type={toast.type}
        duration={1000}
        onClose={() => {
          setToast((prev) => ({ ...prev, open: false }));
          // 3. Navigate after toast closes/timer finishes
          navigate("/admin/scanners");
        }}
      />
      {/* <SuccessModal
        open={showSuccess}
        onClose={() => {setShowSuccess(false);navigate("/admin/scanners");}}
        title="Updated Successfully!"
        message="Scanner has been upadate successfully."
        buttonText="OK"
        buttonBg="bg-[#1A1A1A] hover:bg-[#1A1A1A]"
        buttonTextColor="text-white"
      /> */}
    </>
  );
}
